import React, {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import "./tek.scss";
import "./startTek.scss";
import Itin1StepTekOne from "./steps/itin1/stepTekOne";
import Itin1StepTekTwo from "./steps/itin1/stepTekTwo";
import Itin1StepTekThree from "./steps/itin1/stepTekThree";
import Itin1StepTekFour from "./steps/itin1/stepTekFour";
import Itin1StepTekFive from "./steps/itin1/stepTekFive";
import Itin1StepTekSix from "./steps/itin1/stepTekSix";
import Itin1StepTekSeven from "./steps/itin1/stepTekSeven";
import Itin1StepTekEight from "./steps/itin1/stepTekEight";
import Itin1StepTekNine from "./steps/itin1/stepTekNine";
import Itin2StepTekOne from "./steps/itin2/stepTekOne";
import Itin2StepTekTwo from "./steps/itin2/stepTekTwo";
import Itin2StepTekThree from "./steps/itin2/stepTekThree";
import Itin2StepTekFour from "./steps/itin2/stepTekFour";
import Itin2StepTekFive from "./steps/itin2/stepTekFive";
import Itin2StepTekSix from "./steps/itin2/stepTekSix";
import Itin2StepTekSeven from "./steps/itin2/stepTekSeven";
import Itin2StepTekEight from "./steps/itin2/stepTekEight";
import Itin2StepTekNine from "./steps/itin2/stepTekNine";
import Itin3StepTekOne from "./steps/itin3/stepTekOne";
import Itin3StepTekTwo from "./steps/itin3/stepTekTwo";
import Itin3StepTekThree from "./steps/itin3/stepTekThree";
import Itin3StepTekFour from "./steps/itin3/stepTekFour";
import Itin3StepTekFive from "./steps/itin3/stepTekFive";
import Itin3StepTekSix from "./steps/itin3/stepTekSix";
import Itin3StepTekSeven from "./steps/itin3/stepTekSeven";
import Itin3StepTekEight from "./steps/itin3/stepTekEight";
import Itin3StepTekNine from "./steps/itin3/stepTekNine";
import Itin4StepTekOne from "./steps/itin4/stepTekOne";
import Itin4StepTekTwo from "./steps/itin4/stepTekTwo";
import Itin4StepTekThree from "./steps/itin4/stepTekThree";
import Itin4StepTekFour from "./steps/itin4/stepTekFour";
import Itin4StepTekFive from "./steps/itin4/stepTekFive";
import Itin4StepTekSix from "./steps/itin4/stepTekSix";
import Itin4StepTekSeven from "./steps/itin4/stepTekSeven";
import Itin4StepTekEight from "./steps/itin4/stepTekEight";
import Itin4StepTekNine from "./steps/itin4/stepTekNine";
import {xcService} from "../../../../_services/xcService";
function TekPage(props) {
    const [step, setStep] = useState(1);
    const [userQuest,setUserQuest] = useState();

    const goTo = (number) => {

        setStep(number)
    }

    const setQuest = (course) => {
        const quests = {
            '3º ESO': 'itin1',
            '4º ESO': 'itin2',
            '1º Bachillerato': 'itin3',
            '2º Bachillerato': 'itin4',
            'FP Grado Básico': 'itin2',
            'FP Grado Medio': 'itin4',
        }
        setUserQuest(quests[course])
    }

    useEffect(()=>{
        xcService.getToken('/v1/student/course').then(({data})=>setQuest(data.data.name))
    },[])

    return (!!userQuest &&
        (userQuest === 'itin1') ? <>
            {step === 1 &&
                <Itin1StepTekOne goTo={goTo}/>
            }
            {step === 2 &&
                <Itin1StepTekTwo goTo={goTo}/>
            }
            {step === 3 &&
                <Itin1StepTekThree goTo={goTo}/>
            }
            {step === 4 &&
                <Itin1StepTekFour goTo={goTo}/>
            }
            {step === 5 &&
                <Itin1StepTekFive goTo={goTo}/>
            }
            {step === 6 &&
                <Itin1StepTekSix goTo={goTo}/>
            }
            {step === 7 &&
                <Itin1StepTekSeven goTo={goTo}/>
            }
            {step === 8 &&
                <Itin1StepTekEight goTo={goTo}/>
            }
            {step === 9 &&
                <Itin1StepTekNine goTo={goTo}/>
            }
        </>:
        userQuest==='itin2' ? <>
            {step === 1 &&
                <Itin2StepTekOne  goTo={goTo}  />
            }
            {step === 2 &&
                <Itin2StepTekTwo goTo={goTo} />
            }
            {step === 3 &&
                <Itin2StepTekThree goTo={goTo} />
            }
            {step === 4 &&
                <Itin2StepTekFour goTo={goTo} />
            }
            {step === 5 &&
                <Itin2StepTekFive goTo={goTo} />
            }
            {step === 6 &&
                <Itin2StepTekSix goTo={goTo} />
            }
            {step === 7 &&
                <Itin2StepTekSeven goTo={goTo} />
            }
            {step === 8 &&
                <Itin2StepTekEight goTo={goTo} />
            }
            {step === 9 &&
                <Itin2StepTekNine goTo={goTo} />
            }
        </>:
        userQuest==='itin3' ? <>
            {step === 1 &&
                <Itin3StepTekOne  goTo={goTo}  />
            }
            {step === 2 &&
                <Itin3StepTekTwo goTo={goTo} />
            }
            {step === 3 &&
                <Itin3StepTekThree goTo={goTo} />
            }
            {step === 4 &&
                <Itin3StepTekFour goTo={goTo} />
            }
            {step === 5 &&
                <Itin3StepTekFive goTo={goTo} />
            }
            {step === 6 &&
                <Itin3StepTekSix goTo={goTo} />
            }
            {step === 7 &&
                <Itin3StepTekSeven goTo={goTo} />
            }
            {step === 8 &&
                <Itin3StepTekEight goTo={goTo} />
            }
            {step === 9 &&
                <Itin3StepTekNine goTo={goTo} />
            }
        </>:
        userQuest==='itin4' ? <>
            {step === 1 &&
                <Itin4StepTekOne  goTo={goTo}  />
            }
            {step === 2 &&
                <Itin4StepTekTwo goTo={goTo} />
            }
            {step === 3 &&
                <Itin4StepTekThree goTo={goTo} />
            }
            {step === 4 &&
                <Itin4StepTekFour goTo={goTo} />
            }
            {step === 5 &&
                <Itin4StepTekFive goTo={goTo} />
            }
            {step === 6 &&
                <Itin4StepTekSix goTo={goTo} />
            }
            {step === 7 &&
                <Itin4StepTekSeven goTo={goTo} />
            }
            {step === 8 &&
                <Itin4StepTekEight goTo={goTo} />
            }
            {step === 9 &&
                <Itin4StepTekNine goTo={goTo} />
            }
        </>:null
    )
}

export default withTranslation()(TekPage);
